<template>
	<div>
		<div v-if="showTopAlert">
			<div class="abtg__alert"
			     style="  line-height:40px;height:60px !important; color: white !important;font-size:140%;background-color:#60CD70">
				<strong>Novità!</strong> Automatizza il controllo dei link scaduti.

				<router-link :to="{name: 'N_Tutorial'}"
				             style="text-decoration:underline;  color:white">
					Guarda il tutorial</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	import { createHelpers } from 'vuex-map-fields'

	const { mapFields } = createHelpers({
		getterType: 'user/getField',
		mutationType: 'user/updateField',
	})

	export default {
		name: 'alert',
		data: function() {
			return {
				current: '',
			}
		},

		computed: {
			...mapFields(['userData']),
		},

		created: function() {
			this.checkIfShowTopAlert()
		},

		methods: {
			checkIfShowTopAlert: function() {
				if (1 === 1) {
					this.showTopAlert = false
					setTimeout(() => {
						document.querySelector('.page-content').style.marginTop = "60px";
					}, 500)
				}
			},
		},
	}
</script>

<style scoped>
	/*.abtg__alert {*/
	/*	width: 100%;*/
	/*	height: 40px;*/
	/*	background-color: #313131;*/
	/*	color: yellow;*/
	/*	text-align: center;*/
	/*	padding: 10px;*/
	/*}*/
</style>
